import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import TeamTwo from "../blocks/team/TeamTwo";
import Breadcrumb from "../elements/common/Breadcrumb";
import WhatsAppButton from "../component/WhatsAppButton";
import GoogleMap from "../component/GoogleMap";
import ContactTwo from "../elements/contact/ContactTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import { withTranslation } from 'react-i18next';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Contact extends Component {
    static defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };

    render() {

        const { t } = this.props;

        return (
            <React.Fragment>
                <PageHelmet pageTitle= {t("Contactanos")} />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title = {t("Contactanos")} />
                {/* End Breadcrump Area */}

                {/* Start Team Area */}
                <div className="rn-team-area ptb--80 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--60 mb_sm--0">
                                    <h2 className="title3">{t("Importadores")}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="text-center">
                                <TeamTwo column="col-lg-2" teamStyle="" item={4} />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Team Area */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--120 bg_color--5">
                    <ContactTwo />
                </div>
                {/* End Contact Page Area  */}

                {/* Start Contact Map  */}
                <div className="rn-contact-map-wrapper ptb--80 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--60 mb_sm--0">
                                    <h2 className="title3">{t("ubicacion")}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* Start Single Map  */}
                            <div className="col-lg-12 col-12">
                                <div className="rn-contact-map-area position-relative">
                                    <div>
                                        <GoogleMap />
                                    </div>
                                </div>
                            </div>
                            {/* End Single Map  */}
                        </div>
                    </div>
                </div>
                {/* End Contact Map  */}

                {/* Start Whatsapp Button */}
                <div>
                    <WhatsAppButton />
                </div>
                {/* End Whatsapp Button */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}

export default withTranslation()(Contact);